
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/branchio",
      function () {
        return require("private-next-pages/destinations/branchio.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/branchio"])
      });
    }
  